import React, { useEffect, useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import CtaBand from '../components/CtaBand';

// ─── PROJECT DATA ─────────────────────────────────────────────────────────────

const PROJECTS = [
  {
    title:    'Saintfield Road',
    location: 'Belfast',
    tag:      'Traditional',
    cat:      'traditional',
    cover:    '/images/Saintfield Rd - Belfast.JPG',
    photos:   [
      '/images/Saintfield Rd - Belfast.JPG',
      ...Array.from({ length: 19 }, (_, i) => `/images/Saintfield Rd - Belfast${i + 1}.JPG`),
    ],
  },
  {
    title:    'Purdysburn',
    location: 'Belfast',
    tag:      'Modern',
    cat:      'modern',
    cover:    '/images/Greer-Park.JPG',
    photos:   [
      '/images/Greer-Park.JPG',
      ...Array.from({ length: 15 }, (_, i) => `/images/Greer-Park${i + 1}.JPG`),
    ],
  },
  {
    title:    'Carryduff',
    location: 'Carryduff',
    tag:      'Modern',
    cat:      'modern',
    cover:    '/images/Nuala-kitchen.jpg',
    photos:   [
      '/images/Nuala-kitchen.jpg',
      '/images/Nuala-kitchen1.jpg',
      '/images/Nuala-kitchen2.jpg',
      '/images/Nuala-kitchen3.jpg',
      '/images/Nuala-kitchen4.jpg',
      '/images/Nuala-kitchen5.jpg',
      '/images/Nuala-kitchen7.jpg',
    ],
  },
  {
    title:    'Downpatrick',
    location: 'Co. Down',
    tag:      'Luxury',
    cat:      'luxury',
    cover:    '/images/downpatrick1.jpg',
    photos:   Array.from({ length: 22 }, (_, i) =>
      i === 0 ? '/images/downpatrick.jpg' : `/images/downpatrick${i}.jpg`
    ),
  },
  {
    title:    'Darraghcross',
    location: 'Co. Down',
    tag:      'Contemporary',
    cat:      'contemporary',
    cover:    '/images/Darraghcross1.jpg',
    photos:   Array.from({ length: 10 }, (_, i) => `/images/Darraghcross${i + 1}.jpg`),
  },
  {
    title:    'East Belfast',
    location: 'East Belfast',
    tag:      'Traditional',
    cat:      'traditional',
    cover:    '/images/east-belfast.jpg',
    photos:   [
      '/images/east-belfast.jpg',
      ...Array.from({ length: 7 }, (_, i) => `/images/east-belfast${i + 2}.jpg`),
    ],
  },
  {
    title:    'Lisburn',
    location: 'Lisburn',
    tag:      'Modern',
    cat:      'modern',
    cover:    '/images/lisburn-project1.jpg',
    photos:   Array.from({ length: 4 }, (_, i) => `/images/lisburn-project${i + 1}.jpg`),
  },
  {
    title:    'Hamill Street',
    location: 'Belfast',
    tag:      'Compact',
    cat:      'compact',
    cover:    '/images/hamill-street3.jpg',
    photos:   Array.from({ length: 8 }, (_, i) => `/images/hamill-street${i + 1}.jpg`),
  },
  {
    title:    'Finaghy',
    location: 'Belfast',
    tag:      'Compact',
    cat:      'compact',
    cover:    '/images/finaghy-compact1.jpg',
    photos:   Array.from({ length: 4 }, (_, i) => `/images/finaghy-compact${i + 1}.jpg`),
  },
  {
    title:    'Stranmillis',
    location: 'Belfast',
    tag:      'Compact',
    cat:      'compact',
    cover:    '/images/stranmillis1.jpg',
    photos:   Array.from({ length: 4 }, (_, i) => `/images/stranmillis${i + 1}.jpg`),
  },
  {
    title:    'Carryduff',
    location: 'Belfast',
    tag:      'Traditional',
    cat:      'traditional',
    cover:    '/images/carryduff1.jpg',
    photos:   ['/images/carryduff1.jpg', '/images/carryduff2.jpg'],
  },
  {
    title:    'Hillsborough',
    location: 'Co. Down',
    tag:      'Traditional',
    cat:      'traditional',
    cover:    null,
    photos:   [],
  },
  {
    title:    'Malone Road',
    location: 'Belfast',
    tag:      'Contemporary',
    cat:      'contemporary',
    cover:    null,
    photos:   [],
  },
  {
    title:    'Lisburn',
    location: 'Lisburn',
    tag:      'Modern',
    cat:      'modern',
    cover:    null,
    photos:   [],
  },
  {
    title:    'Holywood',
    location: 'Co. Down',
    tag:      'Luxury',
    cat:      'luxury',
    cover:    null,
    photos:   [],
  },
];

const filters = ['all', 'modern', 'traditional', 'contemporary', 'luxury', 'compact'];

// ─── COMPONENT ────────────────────────────────────────────────────────────────

export default function Gallery() {
  const location = useLocation();

  const [activeFilter, setActiveFilter] = useState('all');
  const [openProject,  setOpenProject]  = useState(null);
  const [photoIndex,   setPhotoIndex]   = useState(0);

  useEffect(() => { window.scrollTo({ top: 0 }); }, []);

  // Auto-open a project when navigated here from the featured section
  useEffect(() => {
    const title = location.state?.openTitle;
    if (!title) return;
    const project = PROJECTS.find(p => p.title === title);
    if (project && project.photos.length) {
      setOpenProject(project);
      setPhotoIndex(0);
      document.body.style.overflow = 'hidden';
    }
  }, [location.state]);

  const filteredProjects = activeFilter === 'all'
    ? PROJECTS
    : PROJECTS.filter(p => p.cat === activeFilter);

  const handleFilter = (f) => {
    setActiveFilter(f);
    setOpenProject(null);
  };

  const openLightbox = (project) => {
    if (!project.photos.length) return;
    setOpenProject(project);
    setPhotoIndex(0);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = useCallback(() => {
    setOpenProject(null);
    document.body.style.overflow = '';
  }, []);

  const goNext = useCallback(() => {
    if (!openProject) return;
    setPhotoIndex(prev => (prev + 1) % openProject.photos.length);
  }, [openProject]);

  const goPrev = useCallback(() => {
    if (!openProject) return;
    setPhotoIndex(prev => (prev - 1 + openProject.photos.length) % openProject.photos.length);
  }, [openProject]);

  useEffect(() => {
    const handleKey = (e) => {
      if (!openProject) return;
      if (e.key === 'Escape')     closeLightbox();
      if (e.key === 'ArrowRight') goNext();
      if (e.key === 'ArrowLeft')  goPrev();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [openProject, closeLightbox, goNext, goPrev]);

  return (
    <div className="page-wrapper--inner">
      <div style={{ height: '60px' }} />
      <section className="section">
        <div className="container">
          <div className="label">Our Portfolio</div>
          <h2 className="heading-xl">
            Crafted<br />
            <span className="orange-italic">Excellence</span>
          </h2>
          <br />
          <p className="subtext" style={{ maxWidth: 600, marginBottom: '3rem' }}>
            Explore our collection of bespoke kitchens, each one a unique reflection
            of our clients' vision and our commitment to exceptional design.
          </p>

          {/* ── FILTER BUTTONS ── */}
          <div style={s.filterRow}>
            <span style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>⊿</span>
            {filters.map(f => (
              <button
                key={f}
                style={{
                  ...s.filterBtn,
                  background:  activeFilter === f ? 'var(--orange)' : 'transparent',
                  color:       activeFilter === f ? '#000' : 'var(--text-muted)',
                  borderColor: activeFilter === f ? 'var(--orange)' : 'var(--border)',
                }}
                onClick={() => handleFilter(f)}
              >
                {f.charAt(0).toUpperCase() + f.slice(1)}
              </button>
            ))}
          </div>

          {/* ── PROJECT GRID ── */}
          <style>{`
            .gal-grid {
              display: grid;
              grid-template-columns: repeat(3, 1fr);
              gap: 1.5rem;
            }
            @media (max-width: 768px) {
              .gal-grid { grid-template-columns: 1fr; }
            }
            .gal-card:hover .gal-card-img {
              transform: scale(1.04);
            }
          `}</style>

          <div className="gal-grid">
            {filteredProjects.map((project, i) => (
              <div
                key={i}
                className="gal-card"
                style={{ ...s.card, cursor: project.photos.length ? 'pointer' : 'default' }}
                onClick={() => openLightbox(project)}
              >
                {project.cover ? (
                  <img
                    src={project.cover}
                    alt={project.title}
                    className="gal-card-img"
                    style={s.cardImg}
                  />
                ) : (
                  <div style={s.cardPlaceholder}>COMING SOON</div>
                )}

                <div style={s.overlay}>
                  <div style={s.galTag}>{project.tag}</div>
                  <div style={s.galTitle}>{project.title}</div>
                  <div style={s.galLoc}>{project.location}</div>
                  {project.photos.length > 0 && (
                    <div style={s.photoCount}>{project.photos.length} photos →</div>
                  )}
                </div>
              </div>
            ))}
          </div>

          <p style={{ textAlign: 'center', color: 'var(--text-dim)', fontSize: '0.8rem', marginTop: '2rem' }}>
            {filteredProjects.length} project{filteredProjects.length !== 1 ? 's' : ''}
          </p>
        </div>
      </section>

      {/* ── LIGHTBOX ── */}
      {openProject && (
        <div style={s.lightboxOverlay} onClick={closeLightbox}>
          <div style={s.lightboxInner} onClick={e => e.stopPropagation()}>

            <button style={s.closeBtn} onClick={closeLightbox}>✕</button>
            <div style={s.counter}>
              {photoIndex + 1} / {openProject.photos.length}
            </div>

            <button style={{ ...s.navBtn, left: '1rem' }} onClick={goPrev}>‹</button>

            <img
              key={openProject.photos[photoIndex]}
              src={openProject.photos[photoIndex]}
              alt={openProject.title}
              style={s.lightboxImg}
            />

            <button style={{ ...s.navBtn, right: '1rem' }} onClick={goNext}>›</button>

            <div style={s.caption}>
              <span style={s.captionTag}>{openProject.tag}</span>
              <span style={s.captionTitle}>{openProject.title}</span>
              <span style={s.captionLoc}>{openProject.location}</span>
            </div>
          </div>

          <div style={s.keyHint}>
            ← → arrow keys to navigate &nbsp;·&nbsp; Esc to close
          </div>
        </div>
      )}

      <CtaBand
        title="Inspired by What You See?"
        text="Let's create something extraordinary for your home."
        buttons={[{ label: 'Book a Consultation', to: '/contact' }]}
      />
    </div>
  );
}

// ─── STYLES ───────────────────────────────────────────────────────────────────
const s = {
  filterRow:    { display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '3rem', flexWrap: 'wrap' },
  filterBtn:    { fontFamily: "'Jost', sans-serif", fontSize: '0.72rem', fontWeight: 500, letterSpacing: '0.12em', textTransform: 'uppercase', padding: '0.5rem 1.2rem', border: '1px solid', cursor: 'pointer', transition: 'all 0.2s' },

  card:         { position: 'relative', overflow: 'hidden' },
  cardImg:      { width: '100%', aspectRatio: '3/4', objectFit: 'cover', display: 'block', transition: 'transform 0.5s ease' },
  cardPlaceholder: { aspectRatio: '3/4', background: 'var(--bg3)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-dim)', fontSize: '0.75rem', letterSpacing: '0.1em', border: '1px dashed var(--border)' },

  overlay:      { position: 'absolute', bottom: 0, left: 0, right: 0, background: 'linear-gradient(transparent, rgba(0,0,0,0.88))', padding: '2rem 1.5rem 1.5rem' },
  galTag:       { fontSize: '0.65rem', fontWeight: 500, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--orange)', marginBottom: '0.3rem' },
  galTitle:     { fontFamily: "'Cormorant Garamond', serif", fontSize: '1.2rem', fontWeight: 500, color: '#fff' },
  galLoc:       { fontSize: '0.78rem', color: 'var(--text-muted)' },
  photoCount:   { fontSize: '0.65rem', color: 'var(--orange)', marginTop: '0.5rem', letterSpacing: '0.08em' },

  lightboxOverlay: { position: 'fixed', inset: 0, zIndex: 2000, background: 'rgba(0,0,0,0.95)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '2rem' },
  lightboxInner:   { position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', maxWidth: '1200px' },
  lightboxImg:     { maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain', display: 'block', boxShadow: '0 25px 80px rgba(0,0,0,0.8)' },

  closeBtn:  { position: 'absolute', top: '-3rem', right: 0, background: 'none', border: '1px solid rgba(255,255,255,0.3)', color: '#fff', fontSize: '1.2rem', width: 40, height: 40, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', transition: 'all 0.2s' },
  counter:   { position: 'absolute', top: '-3rem', left: 0, color: 'var(--text-muted)', fontSize: '0.82rem', letterSpacing: '0.1em' },
  navBtn:    { position: 'absolute', background: 'rgba(232,130,26,0.15)', border: '1px solid rgba(232,130,26,0.4)', color: 'var(--orange)', fontSize: '2.5rem', lineHeight: 1, width: 56, height: 56, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s', zIndex: 1 },
  caption:   { position: 'absolute', bottom: '-3.5rem', left: 0, right: 0, display: 'flex', alignItems: 'center', gap: '1rem', justifyContent: 'center' },
  captionTag:   { fontSize: '0.65rem', fontWeight: 600, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--orange)' },
  captionTitle: { fontFamily: "'Cormorant Garamond', serif", fontSize: '1.1rem', color: '#fff' },
  captionLoc:   { fontSize: '0.78rem', color: 'var(--text-muted)' },
  keyHint:   { position: 'absolute', bottom: '1.5rem', color: 'var(--text-dim)', fontSize: '0.75rem', letterSpacing: '0.05em' },
};
